<script lang="ts">
    import Fa from 'svelte-fa'
    import type { Schedule } from '../../../modules/schedulerApi/schedules/schedule'
    import { SchedulesRepository } from '../../../modules/schedulerApi/schedules/schedules.repository'
    import { SchedulesService } from '../../../modules/schedulerApi/schedules/schedules.service'

    import CompanySelect from './company-select.svelte'
    import { faTimes } from '@fortawesome/free-solid-svg-icons'
    let loaded

    async function evaluateSuccess(ev) {
        if (!(await onboardingOk())) {
            window.self.location.href = '/onboarding'
            return
        }
        window.self.location.href = '/?r=' + new Date().getTime() // window.api.utils.utils.getZanduVersion()
    }

    async function evaluateError(ev) {
        if (ev?.detail === 'Token not allowed for this company.') {
        }
    }

    async function onboardingOk() {
        let onboarding = await window.flags('onboarding')
        if (onboarding === undefined || onboarding === null) {
            try {
                if (self.location.host.includes('prospect.zandu.com.br')) return false
                const schedulerR = new SchedulesRepository()
                const schedulerS = new SchedulesService(schedulerR)
                const schedules: Schedule[] = await schedulerS.getAll()
                const schedulerConfigured = schedules.length > 0
                if (schedulerConfigured) {
                    await window.flags('onboarding', false, true)
                }
                return schedulerConfigured
            } catch (error) {
                return false
            }
        }
        return onboarding
    }

    async function goLogout() {
        await window.api.users.auth.logout(false)
        location.href = '/login'
    }
</script>

<div class="root-company-select-page">
    <div class="box">
        <div class="box_exit">
            <button class="exit" on:click={goLogout}><Fa icon={faTimes}></Fa>&nbsp;Sair</button>
        </div>
        <div class="img">
            <img src="/img/logo_full_white.png" alt="" />
        </div>
        {#if !loaded}
            <div class="label">Aguarde...</div>
        {/if}
        <CompanySelect auto={true} bind:loaded on:success={evaluateSuccess} on:error={evaluateError} />
    </div>
</div>

<style>
    .root-company-select-page {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background: url('/img/bg_login.png') #2f2f2f center center no-repeat;
        background-size: cover;
        padding: 16px 8px;
    }
    .root-company-select-page .box {
        /* From https://css.glass */
        background: rgba(0, 0, 0, 0.72);
        border-radius: 20px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.45);
        backdrop-filter: blur(18px);
        -webkit-backdrop-filter: blur(18px);
        border: 1px solid rgba(255, 255, 255, 0.08);
        padding: 24px 16px;
        flex: 0 1 750px;
        color: white;
        /* sem overflow: hidden — ele recortava a lista do select de fuso horário na borda do cartão */
        position: relative;
    }
    .box .img {
        text-align: center;
        margin-bottom: 24px;
    }
    .box .img img {
        max-width: 150px;
    }

    .box .label {
        margin: 16px 0px 8px 0px;
        color: white;
        text-align: center;
    }

    .box_exit {
        text-align: right;
        margin-bottom: 8px;
        position: absolute;
        right: 16px;
        z-index: 1;
    }
    /* cores explícitas: o cartão é escuro nos dois temas, então um botão que acompanhasse o tema
       ficaria claro sobre escuro no tema claro */
    .box_exit .exit {
        display: inline-flex;
        align-items: center;
        gap: 2px;
        padding: 6px 12px;
        border: 1px solid #ffffff33;
        border-radius: 8px;
        background: #ffffff0f;
        color: #e9e9e9;
        font-size: 13px;
        cursor: pointer;
    }
    .box_exit .exit:hover {
        background: #ffffff1f;
        color: #ffffff;
    }

    @media (max-width: 900px) {
        .root-company-select-page {
            align-items: stretch;
            padding: 0px;
        }
        /* no celular o cartão vira a própria página: o vidro deixaria de ser efeito e viraria um
           borrão colorido atrás do formulário. E o backdrop-filter é bloco de contenção para
           position:fixed — com ele, a lista de tela inteira do select ficava presa dentro do cartão. */
        .root-company-select-page .box {
            flex: 1 1 auto;
            border: 0px;
            border-radius: 0px;
            box-shadow: none;
            background: #232323;
            backdrop-filter: none;
            -webkit-backdrop-filter: none;
            padding: 24px 12px;
        }
    }
</style>
